module.exports = __webpack_public_path__ + "img/refraction-glass-sphere.fc7f4308.png";